import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import { localStore } from './localStore';

export type SessionKey =
  | 'app-user'
  | 'app-foreman'
  | 'app-admin'
  | 'app-impersonate'
  | 'app-impersonate-exiting'
  | 'app-start-impersonate'
  | 'app-href';

export type SessionEndReason =
  | 'signOut'
  | 'signInAgain'
  | 'panelSignIn'
  | 'finalizeFailed'
  | 'passwordReset'
  | 'oauthAdmin'
  | 'oauthUnauthorized'
  | 'unauthorized'
  | 'invitation'
  | 'impersonationEnded';

export const ALL_SESSION_KEYS: SessionKey[] = [
  'app-user',
  'app-foreman',
  'app-admin',
  'app-impersonate',
  'app-impersonate-exiting',
  'app-start-impersonate',
];

export const endSession = (
  reason: SessionEndReason,
  keys: SessionKey[],
  userType?: 'user' | 'admin',
) => {
  Sentry.addBreadcrumb({
    category: 'auth',
    message: `session ended: ${reason}`,
    data: { keys },
    level: 'info',
  });
  posthog?.capture('user_logged_out', { user_type: userType, reason });
  keys.forEach((key) => localStore.removeItem(key));
};
